import { updateItems } from "@/mocks/homeSections";

export default function UpdatesList() {
  return (
    <section id="updates" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              更新动态
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
              线索整理完一批就上线，下面按时间倒序排列最近的变动。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 self-start whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-600">
            <i className="ri-refresh-line"></i>
            近 7 天共 6 次更新
          </span>
        </div>

        <ul className="mt-8 divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {updateItems.map((item) => (
            <li
              key={item.id}
              className="flex flex-col gap-2 px-5 py-4 transition-colors hover:bg-background-100 sm:flex-row sm:items-center sm:justify-between"
            >
              <div className="flex items-center gap-3">
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs whitespace-nowrap text-secondary-900">
                  {item.theme}
                </span>
                <span className="text-sm text-foreground-900">{item.title}</span>
              </div>
              <span className="pl-1 text-xs whitespace-nowrap text-foreground-500 sm:pl-0">
                {item.time}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}